<div class="tw-w-full tw-flex tw-flex-col tw-gap-4 balance-hud">
  <!-- Header Section -->
  <div
    class="tw-flex tw-w-full tw-px-6 tw-py-3 tw-items-center sm:tw-items-start tw-justify-between"
  >
    <div
      class="tw-font-semibold tw-uppercase tw-leading-[125%] tw-tracking-[0.7px] tw-text-[16px] sm:tw-text-[14px]"
      data-testid="balance-hud-period"
    >
      <span class="tw-text-dt-text-secondary">{{ periodPrefix }} </span>
      <span class="tw-text-dt-text-past-primary">{{ periodCount() }}</span>
      <span class="tw-text-dt-text-secondary"> {{ periodUnit() }}</span>
    </div>
    <div class="tw-flex tw-flex-col tw-items-end">
      <span
        class="tw-font-medium tw-text-dt-text-past-primary tw-text-[16px] sm:tw-text-[14px] tw-tracking-[0.004em] tw-leading-[125%]"
        data-testid="balance-hud-date"
        >{{ balanceDate() | date: "MMM yyyy" }}</span
      >
      <span
        class="tw-text-dt-text-tertiary tw-text-[16px] sm:tw-text-[12px] tw-tracking-normal tw-leading-[125%]"
        data-testid="balance-hud-label"
        >{{ hudLabel() | i18n }} ({{ currency() }})</span
      >
    </div>
  </div>

  <!-- Balance HUD Card -->
  <div class="tw-bg-dt-surface-elevated tw-rounded-t-3xl">
    <div
      class="tw-w-full tw-flex tw-flex-col tw-py-4 tw-px-4 sm:tw-px-2 tw-gap-3 tw-bg-dt-surface-elevated tw-rounded-3xl border-gradient-neuomorphic border-active-past tw-shadow-neuomorphic-elevated"
    >
      <div class="tw-flex tw-flex-col tw-w-full tw-pt-3 tw-px-2 sm:tw-pt-0">
        <div class="tw-flex tw-w-full tw-justify-center tw-items-center">
          <span
            class="tw-font-medium tw-text-[40px] sm:tw-text-[36px] tw-leading-[125%] tw-text-center tw-tracking-normal tw-font-D-DIN-PRO tw-antialiased"
            [ngClass]="{
              'tw-text-dt-text-in-primary': balance() > 0.01,
              'tw-text-dt-text-secondary': balance() >= -0.01 && balance() <= 0.01,
              'tw-text-dt-text-out-primary': balance() < -0.01,
            }"
            data-testid="balance-hud-amount"
          >
            @if (useMacroNumber(balance())) {
              {{ balance() | macroNumber }}
            } @else {
              <span>{{ balanceParts().sign }}{{ balanceParts().integer }}</span
              ><span
                class="tw-text-[24px] tw-font-medium tw-leading-[125%] tw-tracking-normal"
                data-testid="balance-hud-decimals"
                >{{ balanceParts().decimals }}</span
              >
            }
          </span>
        </div>
      </div>

      <!--    dropdown-->
      <div
        class="tw-flex tw-w-full tw-flex-col tw-rounded-xl tw-overflow-hidden shadow-neuomorphic-subtle glass-dropdown-panel border-gradient-neuomorphic border-active-past"
      >
        <div
          class="tw-p-4 tw-flex tw-w-full bg-tint-accent-past-60 tw-cursor-pointer"
          (click)="helperCollapse.toggleContent($event)"
          data-testid="balance-hud-per-account-toggle"
        >
          <div
            class="tw-flex tw-w-full tw-gap-1 tw-text-[14px] tw-font-medium tw-leading-[125%] tw-tracking-normal"
          >
            <span>Per Account</span>
            <span class="tw-text-dt-text-tertiary" data-testid="balance-hud-account-count"
              >({{ balanceAccounts()?.length || 0 }})</span
            >
          </div>
          <div>
            <icon
              name="down-arrow"
              [size]="6"
              style="
                transition: transform 200ms cubic-bezier(0.4, 0, 0.2, 1);
                display: inline-block;
              "
              [style.transform]="helperCollapse.isCollapsed ? 'rotate(0deg)' : 'rotate(180deg)'"
            ></icon>
          </div>
        </div>

        <div
          style="overflow: hidden; transition: max-height 300ms cubic-bezier(0.4, 0, 0.2, 1)"
          [style.maxHeight]="helperCollapse.isCollapsed ? '0' : '250px'"
        >
          <!-- GlossScroll overlay bar; caps the list at 5 rows, and at the 250px collapse panel -->
          <app-gloss-scroll [rows]="5" [maxHeight]="250">
            <div class="tw-flex tw-w-full tw-flex-col" data-testid="balance-hud-account-list">
              @for (account of balanceAccounts(); track account.accountID) {
                <div
                  data-gs-row
                  class="tw-w-full tw-flex tw-justify-between tw-px-6 tw-py-3 tw-gap-3 per-account-accent-bar past tw-items-center"
                  [attr.data-testid]="'balance-hud-account-item-' + account.accountID"
                >
                  <span
                    class="tw-leading-[125%] tw-tracking-[0.0125em] tw-text-[14px] sm:tw-text-[12px]"
                    [attr.data-testid]="'balance-hud-account-name-' + account.accountID"
                    >{{ account.account }}</span
                  >
                  <span
                    class="tw-font-medium tw-whitespace-nowrap tw-leading-[125%] tw-tracking-normal tw-text-[18px] sm:tw-text-[16px] tw-font-D-DIN-PRO tw-antialiased"
                    [ngClass]="{
                      'tw-text-dt-text-in-primary': account.balance > 0.01,
                      'tw-text-dt-text-secondary':
                        account.balance >= -0.01 && account.balance <= 0.01,
                      'tw-text-dt-text-out-primary': account.balance < -0.01,
                    }"
                    [attr.data-testid]="'balance-hud-account-balance-' + account.accountID"
                  >
                    @if (useMacroNumber(account.balance)) {
                      {{ account.balance | macroNumber }}
                      <span class="sm:tw-hidden">{{ currency() }}</span>
                    } @else {
                      {{ account.balance | currency: currency() : "" : "1.2-2" }}
                      <span class="sm:tw-hidden">{{ currency() }}</span>
                    }
                  </span>
                </div>
              }
            </div>
          </app-gloss-scroll>
        </div>
      </div>
    </div>
  </div>
</div>
